import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { filter, map, skip, switchMap } from 'rxjs/operators';

import { GetCampaignByIdNoTagsGQL } from 'generated/graphql';

import { selectCampaignId } from '../router/router-selectors';
import { AppRouterState } from '../router/router-state';
import * as CAMPAIGN_CONTEXT_ACTIONS from './campaign-context-actions';
import { CampaignContextState } from './campaign-context-state';

@Injectable()
export class CampaignContextEffects {

  /**
   * Watches for a change in the router campaignId
   * and updates the current campaign context
   * with the campaign object from graphql
   */
  updateCurrentCampaignFromQueryParam$ = createEffect(
    () => this.store.select(
      selectCampaignId
    ).pipe(
      skip(1),
      switchMap((campaignId) => {
        if (!campaignId) {
          return of(
            CAMPAIGN_CONTEXT_ACTIONS.SET_CURRENT_CAMPAIGN({ payload: null })
          );
        } else {
          return this.getCampaignByIdNoTagsGQL.watch({ campaignId })
            .valueChanges
            .pipe(
              filter(res => !res.loading),
              map(({ data }) => data.getCampaign),
              map((campaign) => CAMPAIGN_CONTEXT_ACTIONS.SET_CURRENT_CAMPAIGN({ payload: campaign }))
            );
        }
      })
    )
  );

  constructor(
    private store: Store<AppRouterState & CampaignContextState>,
    private actions$: Actions,
    private getCampaignByIdNoTagsGQL: GetCampaignByIdNoTagsGQL
  ) {
  }
}
